import { render, staticRenderFns } from "./OsLogo.vue?vue&type=template&id=04d7344a&scoped=true"
import script from "./OsLogo.vue?vue&type=script&lang=ts"
export * from "./OsLogo.vue?vue&type=script&lang=ts"
import style0 from "./OsLogo.vue?vue&type=style&index=0&id=04d7344a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7344a",
  null
  
)

export default component.exports